module.exports = __webpack_public_path__ + "static/media/7f12bdd2-7c86-4f1a-b591-d5490d269718.b0337ea3.jpeg";